import * as config from '@obeta/utils/lib/config'
import { from, HttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getAuthorizationHeader } from '../getAuthorizationHeader'
import { type RxDatabase } from 'rxdb'
import { type AppActions } from '@obeta/models/lib/models/BusinessLayer/AppActions'

type Props = {
  appActions: AppActions
  db: RxDatabase
}

export default function getEndpoint(props: Props) {
  const { appActions, db } = props

  const withToken = setContext(async (request, prevContext) => {
    const authorizationHeader = await getAuthorizationHeader(appActions)
    const client = await db.getLocal('client')
    const frontendClientId = client?.get('frontendClientId')

    return {
      ...prevContext,
      headers: {
        ...prevContext.headers,
        ...authorizationHeader,
        'x-frontend-client-id': frontendClientId,
      },
    }
  })

  const endpoint = new HttpLink({
    uri: config.GRAPHQL_HOST,
  })

  return from([withToken, endpoint])
}
